/**
 * Default translator sections for Lamentations (LAM)
 * Generated from unfoldingWord/en_ult repository
 * Extracted: 2025-08-24T14:26:58.290Z
 * Sections: 67
 */

import type { TranslatorSection } from '@bt-synergy/scripture-loader';

export const lamSections: TranslatorSection[] = [
  {
    "start": {
      "chapter": 1,
      "verse": 1,
      "reference": {
        "chapter": "1",
        "verse": "1"
      }
    },
    "end": {
      "chapter": 1,
      "verse": 1,
      "reference": {
        "chapter": "1",
        "verse": "1"
      }
    }
  },
  {
    "start": {
      "chapter": 1,
      "verse": 2,
      "reference": {
        "chapter": "1",
        "verse": "2"
      }
    },
    "end": {
      "chapter": 1,
      "verse": 2,
      "reference": {
        "chapter": "1",
        "verse": "2"
      }
    }
  },
  {
    "start": {
      "chapter": 1,
      "verse": 3,
      "reference": {
        "chapter": "1",
        "verse": "3"
      }
    },
    "end": {
      "chapter": 1,
      "verse": 4,
      "reference": {
        "chapter": "1",
        "verse": "4"
      }
    }
  },
  {
    "start": {
      "chapter": 1,
      "verse": 5,
      "reference": {
        "chapter": "1",
        "verse": "5"
      }
    },
    "end": {
      "chapter": 1,
      "verse": 5,
      "reference": {
        "chapter": "1",
        "verse": "5"
      }
    }
  },
  {
    "start": {
      "chapter": 1,
      "verse": 6,
      "reference": {
        "chapter": "1",
        "verse": "6"
      }
    },
    "end": {
      "chapter": 1,
      "verse": 6,
      "reference": {
        "chapter": "1",
        "verse": "6"
      }
    }
  },
  {
    "start": {
      "chapter": 1,
      "verse": 7,
      "reference": {
        "chapter": "1",
        "verse": "7"
      }
    },
    "end": {
      "chapter": 1,
      "verse": 8,
      "reference": {
        "chapter": "1",
        "verse": "8"
      }
    }
  },
  {
    "start": {
      "chapter": 1,
      "verse": 9,
      "reference": {
        "chapter": "1",
        "verse": "9"
      }
    },
    "end": {
      "chapter": 1,
      "verse": 9,
      "reference": {
        "chapter": "1",
        "verse": "9"
      }
    }
  },
  {
    "start": {
      "chapter": 1,
      "verse": 10,
      "reference": {
        "chapter": "1",
        "verse": "10"
      }
    },
    "end": {
      "chapter": 1,
      "verse": 11,
      "reference": {
        "chapter": "1",
        "verse": "11"
      }
    }
  },
  {
    "start": {
      "chapter": 1,
      "verse": 12,
      "reference": {
        "chapter": "1",
        "verse": "12"
      }
    },
    "end": {
      "chapter": 1,
      "verse": 13,
      "reference": {
        "chapter": "1",
        "verse": "13"
      }
    }
  },
  {
    "start": {
      "chapter": 1,
      "verse": 14,
      "reference": {
        "chapter": "1",
        "verse": "14"
      }
    },
    "end": {
      "chapter": 1,
      "verse": 14,
      "reference": {
        "chapter": "1",
        "verse": "14"
      }
    }
  },
  {
    "start": {
      "chapter": 1,
      "verse": 15,
      "reference": {
        "chapter": "1",
        "verse": "15"
      }
    },
    "end": {
      "chapter": 1,
      "verse": 16,
      "reference": {
        "chapter": "1",
        "verse": "16"
      }
    }
  },
  {
    "start": {
      "chapter": 1,
      "verse": 17,
      "reference": {
        "chapter": "1",
        "verse": "17"
      }
    },
    "end": {
      "chapter": 1,
      "verse": 18,
      "reference": {
        "chapter": "1",
        "verse": "18"
      }
    }
  },
  {
    "start": {
      "chapter": 1,
      "verse": 19,
      "reference": {
        "chapter": "1",
        "verse": "19"
      }
    },
    "end": {
      "chapter": 1,
      "verse": 19,
      "reference": {
        "chapter": "1",
        "verse": "19"
      }
    }
  },
  {
    "start": {
      "chapter": 1,
      "verse": 20,
      "reference": {
        "chapter": "1",
        "verse": "20"
      }
    },
    "end": {
      "chapter": 1,
      "verse": 21,
      "reference": {
        "chapter": "1",
        "verse": "21"
      }
    }
  },
  {
    "start": {
      "chapter": 1,
      "verse": 22,
      "reference": {
        "chapter": "1",
        "verse": "22"
      }
    },
    "end": {
      "chapter": 2,
      "verse": 1,
      "reference": {
        "chapter": "2",
        "verse": "1"
      }
    }
  },
  {
    "start": {
      "chapter": 2,
      "verse": 2,
      "reference": {
        "chapter": "2",
        "verse": "2"
      }
    },
    "end": {
      "chapter": 2,
      "verse": 3,
      "reference": {
        "chapter": "2",
        "verse": "3"
      }
    }
  },
  {
    "start": {
      "chapter": 2,
      "verse": 4,
      "reference": {
        "chapter": "2",
        "verse": "4"
      }
    },
    "end": {
      "chapter": 2,
      "verse": 5,
      "reference": {
        "chapter": "2",
        "verse": "5"
      }
    }
  },
  {
    "start": {
      "chapter": 2,
      "verse": 6,
      "reference": {
        "chapter": "2",
        "verse": "6"
      }
    },
    "end": {
      "chapter": 2,
      "verse": 6,
      "reference": {
        "chapter": "2",
        "verse": "6"
      }
    }
  },
  {
    "start": {
      "chapter": 2,
      "verse": 7,
      "reference": {
        "chapter": "2",
        "verse": "7"
      }
    },
    "end": {
      "chapter": 2,
      "verse": 8,
      "reference": {
        "chapter": "2",
        "verse": "8"
      }
    }
  },
  {
    "start": {
      "chapter": 2,
      "verse": 9,
      "reference": {
        "chapter": "2",
        "verse": "9"
      }
    },
    "end": {
      "chapter": 2,
      "verse": 9,
      "reference": {
        "chapter": "2",
        "verse": "9"
      }
    }
  },
  {
    "start": {
      "chapter": 2,
      "verse": 10,
      "reference": {
        "chapter": "2",
        "verse": "10"
      }
    },
    "end": {
      "chapter": 2,
      "verse": 11,
      "reference": {
        "chapter": "2",
        "verse": "11"
      }
    }
  },
  {
    "start": {
      "chapter": 2,
      "verse": 12,
      "reference": {
        "chapter": "2",
        "verse": "12"
      }
    },
    "end": {
      "chapter": 2,
      "verse": 13,
      "reference": {
        "chapter": "2",
        "verse": "13"
      }
    }
  },
  {
    "start": {
      "chapter": 2,
      "verse": 14,
      "reference": {
        "chapter": "2",
        "verse": "14"
      }
    },
    "end": {
      "chapter": 2,
      "verse": 15,
      "reference": {
        "chapter": "2",
        "verse": "15"
      }
    }
  },
  {
    "start": {
      "chapter": 2,
      "verse": 16,
      "reference": {
        "chapter": "2",
        "verse": "16"
      }
    },
    "end": {
      "chapter": 2,
      "verse": 16,
      "reference": {
        "chapter": "2",
        "verse": "16"
      }
    }
  },
  {
    "start": {
      "chapter": 2,
      "verse": 17,
      "reference": {
        "chapter": "2",
        "verse": "17"
      }
    },
    "end": {
      "chapter": 2,
      "verse": 18,
      "reference": {
        "chapter": "2",
        "verse": "18"
      }
    }
  },
  {
    "start": {
      "chapter": 2,
      "verse": 19,
      "reference": {
        "chapter": "2",
        "verse": "19"
      }
    },
    "end": {
      "chapter": 2,
      "verse": 19,
      "reference": {
        "chapter": "2",
        "verse": "19"
      }
    }
  },
  {
    "start": {
      "chapter": 2,
      "verse": 20,
      "reference": {
        "chapter": "2",
        "verse": "20"
      }
    },
    "end": {
      "chapter": 2,
      "verse": 21,
      "reference": {
        "chapter": "2",
        "verse": "21"
      }
    }
  },
  {
    "start": {
      "chapter": 2,
      "verse": 22,
      "reference": {
        "chapter": "2",
        "verse": "22"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 3,
      "reference": {
        "chapter": "3",
        "verse": "3"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 4,
      "reference": {
        "chapter": "3",
        "verse": "4"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 7,
      "reference": {
        "chapter": "3",
        "verse": "7"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 8,
      "reference": {
        "chapter": "3",
        "verse": "8"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 10,
      "reference": {
        "chapter": "3",
        "verse": "10"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 11,
      "reference": {
        "chapter": "3",
        "verse": "11"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 14,
      "reference": {
        "chapter": "3",
        "verse": "14"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 15,
      "reference": {
        "chapter": "3",
        "verse": "15"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 17,
      "reference": {
        "chapter": "3",
        "verse": "17"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 18,
      "reference": {
        "chapter": "3",
        "verse": "18"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 20,
      "reference": {
        "chapter": "3",
        "verse": "20"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 21,
      "reference": {
        "chapter": "3",
        "verse": "21"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 23,
      "reference": {
        "chapter": "3",
        "verse": "23"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 24,
      "reference": {
        "chapter": "3",
        "verse": "24"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 28,
      "reference": {
        "chapter": "3",
        "verse": "28"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 29,
      "reference": {
        "chapter": "3",
        "verse": "29"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 32,
      "reference": {
        "chapter": "3",
        "verse": "32"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 33,
      "reference": {
        "chapter": "3",
        "verse": "33"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 35,
      "reference": {
        "chapter": "3",
        "verse": "35"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 36,
      "reference": {
        "chapter": "3",
        "verse": "36"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 38,
      "reference": {
        "chapter": "3",
        "verse": "38"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 39,
      "reference": {
        "chapter": "3",
        "verse": "39"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 42,
      "reference": {
        "chapter": "3",
        "verse": "42"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 43,
      "reference": {
        "chapter": "3",
        "verse": "43"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 46,
      "reference": {
        "chapter": "3",
        "verse": "46"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 47,
      "reference": {
        "chapter": "3",
        "verse": "47"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 49,
      "reference": {
        "chapter": "3",
        "verse": "49"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 50,
      "reference": {
        "chapter": "3",
        "verse": "50"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 53,
      "reference": {
        "chapter": "3",
        "verse": "53"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 54,
      "reference": {
        "chapter": "3",
        "verse": "54"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 56,
      "reference": {
        "chapter": "3",
        "verse": "56"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 57,
      "reference": {
        "chapter": "3",
        "verse": "57"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 60,
      "reference": {
        "chapter": "3",
        "verse": "60"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 61,
      "reference": {
        "chapter": "3",
        "verse": "61"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 62,
      "reference": {
        "chapter": "3",
        "verse": "62"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 63,
      "reference": {
        "chapter": "3",
        "verse": "63"
      }
    },
    "end": {
      "chapter": 3,
      "verse": 65,
      "reference": {
        "chapter": "3",
        "verse": "65"
      }
    }
  },
  {
    "start": {
      "chapter": 3,
      "verse": 66,
      "reference": {
        "chapter": "3",
        "verse": "66"
      }
    },
    "end": {
      "chapter": 4,
      "verse": 1,
      "reference": {
        "chapter": "4",
        "verse": "1"
      }
    }
  },
  {
    "start": {
      "chapter": 4,
      "verse": 2,
      "reference": {
        "chapter": "4",
        "verse": "2"
      }
    },
    "end": {
      "chapter": 4,
      "verse": 2,
      "reference": {
        "chapter": "4",
        "verse": "2"
      }
    }
  },
  {
    "start": {
      "chapter": 4,
      "verse": 3,
      "reference": {
        "chapter": "4",
        "verse": "3"
      }
    },
    "end": {
      "chapter": 4,
      "verse": 4,
      "reference": {
        "chapter": "4",
        "verse": "4"
      }
    }
  },
  {
    "start": {
      "chapter": 4,
      "verse": 5,
      "reference": {
        "chapter": "4",
        "verse": "5"
      }
    },
    "end": {
      "chapter": 4,
      "verse": 5,
      "reference": {
        "chapter": "4",
        "verse": "5"
      }
    }
  },
  {
    "start": {
      "chapter": 4,
      "verse": 6,
      "reference": {
        "chapter": "4",
        "verse": "6"
      }
    },
    "end": {
      "chapter": 4,
      "verse": 7,
      "reference": {
        "chapter": "4",
        "verse": "7"
      }
    }
  },
  {
    "start": {
      "chapter": 4,
      "verse": 8,
      "reference": {
        "chapter": "4",
        "verse": "8"
      }
    },
    "end": {
      "chapter": 4,
      "verse": 9,
      "reference": {
        "chapter": "4",
        "verse": "9"
      }
    }
  },
  {
    "start": {
      "chapter": 4,
      "verse": 10,
      "reference": {
        "chapter": "4",
        "verse": "10"
      }
    },
    "end": {
      "chapter": 4,
      "verse": 10,
      "reference": {
        "chapter": "4",
        "verse": "10"
      }
    }
  },
  {
    "start": {
      "chapter": 4,
      "verse": 11,
      "reference": {
        "chapter": "4",
        "verse": "11"
      }
    },
    "end": {
      "chapter": 4,
      "verse": 12,
      "reference": {
        "chapter": "4",
        "verse": "12"
      }
    }
  },
  {
    "start": {
      "chapter": 4,
      "verse": 13,
      "reference": {
        "chapter": "4",
        "verse": "13"
      }
    },
    "end": {
      "chapter": 4,
      "verse": 14,
      "reference": {
        "chapter": "4",
        "verse": "14"
      }
    }
  },
  {
    "start": {
      "chapter": 4,
      "verse": 15,
      "reference": {
        "chapter": "4",
        "verse": "15"
      }
    },
    "end": {
      "chapter": 4,
      "verse": 15,
      "reference": {
        "chapter": "4",
        "verse": "15"
      }
    }
  },
  {
    "start": {
      "chapter": 4,
      "verse": 16,
      "reference": {
        "chapter": "4",
        "verse": "16"
      }
    },
    "end": {
      "chapter": 4,
      "verse": 17,
      "reference": {
        "chapter": "4",
        "verse": "17"
      }
    }
  },
  {
    "start": {
      "chapter": 4,
      "verse": 18,
      "reference": {
        "chapter": "4",
        "verse": "18"
      }
    },
    "end": {
      "chapter": 4,
      "verse": 19,
      "reference": {
        "chapter": "4",
        "verse": "19"
      }
    }
  },
  {
    "start": {
      "chapter": 4,
      "verse": 20,
      "reference": {
        "chapter": "4",
        "verse": "20"
      }
    },
    "end": {
      "chapter": 4,
      "verse": 21,
      "reference": {
        "chapter": "4",
        "verse": "21"
      }
    }
  },
  {
    "start": {
      "chapter": 4,
      "verse": 22,
      "reference": {
        "chapter": "4",
        "verse": "22"
      }
    },
    "end": {
      "chapter": 5,
      "verse": 3,
      "reference": {
        "chapter": "5",
        "verse": "3"
      }
    }
  },
  {
    "start": {
      "chapter": 5,
      "verse": 4,
      "reference": {
        "chapter": "5",
        "verse": "4"
      }
    },
    "end": {
      "chapter": 5,
      "verse": 6,
      "reference": {
        "chapter": "5",
        "verse": "6"
      }
    }
  },
  {
    "start": {
      "chapter": 5,
      "verse": 7,
      "reference": {
        "chapter": "5",
        "verse": "7"
      }
    },
    "end": {
      "chapter": 5,
      "verse": 9,
      "reference": {
        "chapter": "5",
        "verse": "9"
      }
    }
  },
  {
    "start": {
      "chapter": 5,
      "verse": 10,
      "reference": {
        "chapter": "5",
        "verse": "10"
      }
    },
    "end": {
      "chapter": 5,
      "verse": 11,
      "reference": {
        "chapter": "5",
        "verse": "11"
      }
    }
  },
  {
    "start": {
      "chapter": 5,
      "verse": 12,
      "reference": {
        "chapter": "5",
        "verse": "12"
      }
    },
    "end": {
      "chapter": 5,
      "verse": 13,
      "reference": {
        "chapter": "5",
        "verse": "13"
      }
    }
  },
  {
    "start": {
      "chapter": 5,
      "verse": 14,
      "reference": {
        "chapter": "5",
        "verse": "14"
      }
    },
    "end": {
      "chapter": 5,
      "verse": 15,
      "reference": {
        "chapter": "5",
        "verse": "15"
      }
    }
  },
  {
    "start": {
      "chapter": 5,
      "verse": 16,
      "reference": {
        "chapter": "5",
        "verse": "16"
      }
    },
    "end": {
      "chapter": 5,
      "verse": 17,
      "reference": {
        "chapter": "5",
        "verse": "17"
      }
    }
  },
  {
    "start": {
      "chapter": 5,
      "verse": 18,
      "reference": {
        "chapter": "5",
        "verse": "18"
      }
    },
    "end": {
      "chapter": 5,
      "verse": 66,
      "reference": {
        "chapter": "5",
        "verse": "66"
      }
    }
  }
];

export const lamMetadata = {
  bookCode: 'LAM',
  bookName: 'Lamentations',
  sectionsCount: 67,
  extractedAt: '2025-08-24T14:26:58.290Z'
};
